import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {PhotoDownload} from '../models/photo-download';

export interface PhotoDownloadService {
    detail(fileName: string): Observable<PhotoDownload>;
    enqueue(projectReferenceId: number): Observable<PhotoDownload>;
}

@Injectable({
    providedIn: 'root'
})
export class PhotoDownloadServiceImpl implements PhotoDownloadService {
    protected http = inject(HttpClient);


    detail(fileName: string): Observable<PhotoDownload> {
        return this.http.get<PhotoDownload>(`/api/v1/photo-downloads/${fileName}`);
    }

    enqueue(projectReferenceId: number): Observable<PhotoDownload> {
        return this.http.post<PhotoDownload>(`/api/v1/photo-downloads/enqueue`, {projectReferenceId});
    }
}
